<div class="row col-md-12">
    <h6 class="mb-0"><b>Generate Forms</b></h6>
</div>
<div class="row col-md-12">
    <p style="font-size:12px"><i>You will need all the following documents for filing</i></p>
</div>

<!-- Form I-140 START -->
<div class="row form-box d-flex align-items-center mb-10">

    <div class="col-12">
      <label><b>Form I-140</b></label> 
      <p style="font-size: 14px;">Would you like to use system generated form or upload your own form?</p>
      <lib-override-radio-button-library  [primaryData]="stepDetails" [fileName]="'I140'" [isGenerated]="generateFormI140" (generateUpload)="getInfoBack($event)"></lib-override-radio-button-library>
      
    </div>
  
    <div class="clearfix"></div>
    <!-- Generate Form -->
    <div class="generateBtnContainer row" *ngIf="generateFormI140">
      <div class="col-2">
        <button pButton class="btn-success button-width-icon-left btn-small mr-1 pl-3 pr-3 save-btn" (click)="postGenerateDoc('I140')"
          label="Generate" title="Generate" [disabled]="disabledControls"></button>
      </div>
  
      <div class="col-3" *ngIf="(generateFormI140) && (isActive140)">
        <button pButton type="button" label="View PDF" title="View PDF" class="p-button-outlined btn-small" (click)="viewGenerateDoc(i140Src)"></button>
      </div>
  
      <div class="col-5" *ngIf="(generateFormI140) && (isActive140)">
        <span>
          {{(gi140lastDocDate)? 'Generated On '+ gi140lastDocDate : ''}} 
        </span>
      </div> 
    </div>
    <!-- Generate Form -->
  
    <div class="col-12">
      <lib-overide-upload-forms-library [uploadedFileName]="uploadedFileName140" 
      [isGreenCard]="true" [documentID]="documentId140" [fileSrc]="i140Src" 
      [UploadingTime]="gi140lastDocDate" [isUploaded]="uploadedFormI140" 
      [isGenerated]="generateFormI140" [primaryData]="stepDetails" [formName]="'I140'" 
      (uploadData)="getUploadedData($event)" (deleteData)="getDeletedData($event)"></lib-overide-upload-forms-library>
    </div>
  
</div>
<!-- Form I-140 END -->


<!-- Form G-1450 -->
<div class="mb-4" *ngIf="enotificationAndCCDetails?.isAuthCreditCardTrans === 1">
  <div class="row col-md-12 pt-4 ">
    <h6 style="font-size:14px"><b>G-1450</b></h6>
  </div>
  <div class="row form-box d-flex align-items-center pb-3">
    <div class="col-2 pr-0">
      <label>Form G-1450</label>
    </div>
    <div class="col-2">
      <button pButton class="btn-success button-width-icon-left mr-1 pl-3 pr-3 save-btn"
        (click)="postGenerateDoc('G1450')" label="Generate" title="Generate" [disabled]="disabledControls"></button>
    </div>
    <div class="col-3">
      <button pButton type="button" label="View PDF" title="View PDF" class="p-button-outlined" *ngIf="this.gi1450Src"
        (click)="viewGenerateDoc(this.gi1450Src)"></button>
    </div>
    <div class="col-5">
      <span *ngIf="this.gi1450Src"> {{(this.gi1450lastDocDate)? 'Generated On '+ this.gi1450lastDocDate :
        ''}} </span>
    </div>
  </div>
</div>
<!-- Form G-1145 -->
<div class="mb-4" *ngIf="enotificationAndCCDetails?.isEnotifyReqd === 1">
  <div class="row col-md-12 pt-4 ">
    <h6 style="font-size:14px"><b>G-1145</b></h6>
  </div>
  <div class="row form-box d-flex align-items-center pb-3">
    <div class="col-2 pr-0">
      <label>Form G-1145</label>
    </div>
    <div class="col-2">
      <button pButton class="btn-success button-width-icon-left mr-1 pl-3 pr-3 save-btn"
        (click)="postGenerateDoc('G1145')" label="Generate" title="Generate" [disabled]="disabledControls"></button>
    </div>
    <div class="col-3">
      <button pButton type="button" label="View PDF" title="View PDF" class="p-button-outlined" *ngIf="this.gi1145Src"
        (click)="viewGenerateDoc(this.gi1145Src)"></button>
    </div>
    <div class="col-5">
      <span *ngIf="this.gi1145Src"> {{(this.gi1145lastDocDate)? 'Generated On '+ this.gi1145lastDocDate :
        ''}} </span>
    </div>
  </div>
</div>



<!-- Form I-907 START -->
<div class="row form-box d-flex align-items-center  mb-10"  *ngIf="subTaskDetails?.serviceCenterDetails?.isPremiumCenter === 1">

    <div class="col-12" *ngIf="subTaskDetails?.serviceCenterDetails?.isPremiumCenter === 1">
      <label><b>Form I-907</b></label> 
      <p style="font-size: 14px;">Would you like to use system generated form or upload your own form?</p>
      <lib-override-radio-button-library  [primaryData]="subTaskDetails" [fileName]="'I907'" [isGenerated]="generateFormI907" (generateUpload)="getInfoBack($event)"></lib-override-radio-button-library>
    </div>
  
    <div class="clearfix"></div>
    <!-- Generate Form -->
    <div class="generateBtnContainer row" *ngIf="generateFormI907">
      <div class="col-2">
        <button pButton class="btn-success button-width-icon-left btn-small mr-1 pl-3 pr-3 save-btn" (click)="postGenerateDoc('I907')"
          label="Generate" title="Generate" [disabled]="disabledControls"></button>
      </div>
  
      <div class="col-3" *ngIf="(generateFormI907) && (isActive907)">
        <button pButton type="button" label="View PDF" title="View PDF" class="p-button-outlined btn-small" (click)="viewGenerateDoc(i907Src)"></button>
      </div>
  
      <div class="col-5" *ngIf="(generateFormI907) && (isActive907)">
        <span>
          {{(i907lastDocDate)? 'Generated On '+ i907lastDocDate : ''}} 
        </span>
      </div>
    </div>
    <!-- Generate Form -->
  
    <div class="col-12">
      <lib-overide-upload-forms-library [uploadedFileName]="uploadedFileName907" [isGreenCard]="true" [documentID]="documentId907" [fileSrc]="i907Src" [UploadingTime]="i907lastDocDate" [isUploaded]="uploadedFormI907" [isGenerated]="generateFormI907" [primaryData]="stepDetails" [formName]="'I907'" (uploadData)="getUploadedData($event)" (deleteData)="getDeletedData($event)"></lib-overide-upload-forms-library>
    </div>
    
  
</div>
<!-- Form I-907 END -->


<!-- Form I-G28 START -->
<div class="row form-box d-flex align-items-center  mb-10"   *ngIf="stepDetails.attorneyId">

    <div class="col-12" *ngIf="stepDetails.attorneyId">
      <label><b>Form G-28</b></label> 
      <p style="font-size: 14px;">Would you like to use system generated form or upload your own form?</p>
      <lib-override-radio-button-library  [primaryData]="subTaskDetails" [fileName]="'G28'" [isGenerated]="generateFormG28" (generateUpload)="getInfoBack($event)"></lib-override-radio-button-library>
    </div>
  
    <div class="clearfix"></div>
    <!-- Generate Form -->
    <div class="generateBtnContainer row" *ngIf="generateFormG28">
      <div class="col-2">
        <button pButton class="btn-success button-width-icon-left btn-small mr-1 pl-3 pr-3 save-btn" (click)="postGenerateDoc('G28')"
          label="Generate" title="Generate" [disabled]="disabledControls"></button>
      </div>
  
      <div class="col-3" *ngIf="(generateFormG28) && (isActiveG28)">
        <button pButton type="button" label="View PDF" title="View PDF" class="p-button-outlined btn-small" (click)="viewGenerateDoc(g28Src)"></button>
      </div>
  
      <div class="col-5" *ngIf="(generateFormG28) && (isActiveG28)">
        <span>
          {{(g28lastDocDate)? 'Generated On '+ g28lastDocDate : ''}} 
        </span>
      </div>
    </div>
    <!-- Generate Form -->
  
    <div class="col-12">
      <lib-overide-upload-forms-library [uploadedFileName]="uploadedFileNameG28" [isGreenCard]="true"  [documentID]="documentIdG28" [fileSrc]="g28Src" [UploadingTime]="g28lastDocDate" [isUploaded]="uploadedFormG28" [isGenerated]="generateFormG28" [primaryData]="stepDetails" [formName]="'G28'" (uploadData)="getUploadedData($event)" (deleteData)="getDeletedData($event)"></lib-overide-upload-forms-library>
    </div>
    
  
</div>
<!-- Form G28 END -->












